export function allPayablesCustomCells () {
  return [
    {
      slotName: 'net-weight',
      value: 'netWeight'
    },
    {
      slotName: 'defect-weight',
      value: 'defectWeight'
    },
    {
      slotName: 'gross-weight',
      value: 'gross'
    },
    {
      slotName: 'pay-on',
      value: 'computedAtPayOn'
    },
    {
      slotName: 'pay-by',
      value: 'computedAtPayBy'
    },
    {
      slotName: 'product',
      value: 'product'
    },
    {
      slotName: 'computed-at',
      value: 'computedAt',
      dateFormat: ('MM/DD/YYYY')
    },
    {
      slotName: 'computedAtRate',
      value: 'computedAtRate'
    },
    {
      slotName: 'amount',
      value: 'amount'
    },
    {
      slotName: 'grossAmount',
      value: 'grossAmount'
    },
    {
      slotName: 'recovered',
      value: 'recovered'
    },
    {
      slotName: 'actions',
      value: 'actions'
    },
    {
      slotName: 'activityWithSplit',
      value: 'activityWithSplit'
    }
  ]
}

export function payablesByAccountCustomCells () {
  return [
    {
      slotName: 'average-rate',
      value: 'averageRate'
    },
    {
      slotName: 'total-tickets',
      value: 'totalTickets'
    },
    {
      slotName: 'total-payable',
      value: 'totalPayable'
    },
    {
      slotName: 'total-net-weight',
      value: 'totalNetTons'
    },
    {
      slotName: 'actions',
      value: 'actions'
    }
  ]
}
